import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { displayErrorText } from '../../../../api/errors/api-error-codes';
import {
  CrmAccountType,
  CrmVatStatus,
} from '../../../../api/types/crm/accounts/crm-account-entity';

export const createCrmAccountOperation = async (
  payload: {
    accountName: string;
    accountType: CrmAccountType | null;
    vatStatus: CrmVatStatus | null;
    registrationNumber: string | null;
    email: string | null;
    phone: string | null;
    address: string | null;
    notes: string | null;
  },
  setLoading: (loading: boolean) => any,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.createCrmAccount({
      accountName: payload.accountName,
      accountType: payload.accountType,
      vatStatus: payload.vatStatus,
      registrationNumber: payload.registrationNumber,
      email: payload.email,
      phone: payload.phone,
      address: payload.address,
      notes: payload.notes,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('הארגון נוצר בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
